import Button from "../../components/ui-lib/buttons/Button";
import { ComponentStyles } from "../../helpers/constants/styles";
import { Dialog, Menu } from "@headlessui/react";
import { useState } from "react";
import ListBox from "../../components/ui-lib/ListBox";
import { TestForm } from "./TestForm";
import { Input } from "../../components/ui-lib/Input";
import UiDialog from "../../components/ui-lib/UiDialog";
import { useQuery } from "react-query";
import axios from "axios";
import Toggle from "../../components/ui-lib/Toggle";
import Card from "../../components/Test";
import Wizard from "../../components/Wizard";
import {
  NidComboboxMulti,
  NidComboboxSingle,
} from "../../components/ui-lib/Combobox";
import { TextArea } from "../../components/ui-lib/TextArea";
import FullscreenUiDialog from "../../components/ui-lib/FullscreenDialog";
import CreateExternalTeacherDialog from "../../components/vacancy/CreateExternalTeacherDialog";
import { Float } from "@headlessui-float/react";
import { useVacancyApi } from "../../apis/vacancy-api";
import EditableInput from "../../components/ui-lib/EditableInput";

const peopleApi = () =>
  Promise.resolve([
    { id: 1, name: "Durward Reynolds", unavailable: false },
    { id: 2, name: "Kenton Towne", unavailable: false },
    { id: 3, name: "Therese Wunsch", unavailable: false },
    { id: 4, name: "Benedict Kessler", unavailable: true },
    { id: 5, name: "Katelyn Rohan", unavailable: false },
    { id: 6, name: "Severin Haas", unavailable: false },
    { id: 7, name: "Jan Kuonen", unavailable: false },
    { id: 8, name: "Manuel Käch", unavailable: false },
    { id: 9, name: "Lea Muster", unavailable: false },
  ]);

const elements = ["Item 1", "Item 2", "Item 3", "Item 4", "Item 5"];

function Playground() {
  elements.find((a) => a);

  const { data: people } = useQuery(["p"], peopleApi);
  const [selectedPerson, setSelectedPerson] = useState<
    { id: number; name: string; unavailable: boolean } | undefined
  >();
  const [selectedElement, setSelectedElement] = useState<
    { id: number; name: string; unavailable: boolean } | undefined
  >();
  const [selectedElementMulti, setSelectedElementMulti] = useState<
    { id: number; name: string; unavailable: boolean }[] | undefined
  >([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);
  const [isTeacherDialogOpen, setIsTeacherDialogOpen] = useState(false);

  const [stepOneValid, setStepOneValid] = useState(false);

  const loadFact = async () => {
    const r = await axios.get("https://catfact.ninja/fact");
    return r.data.fact;
  };

  const { getVacancies } = useVacancyApi();

  const loadVacancies = async () => {
    const message = await getVacancies({ sortBy: "startDate" });
    return console.log(message);
  };

  const {
    data: fact,
    isFetching: isLoadingfact,
    refetch: fetchFact,
  } = useQuery("fact", {
    queryFn: loadFact,
    enabled: false,
  });

  const { refetch: fetchVacancies } = useQuery(["vacancies", "playground"], {
    queryFn: loadVacancies,
    enabled: false,
  });

  const titles = ["lessons", "lessons", "lessons"];
  const duration = ["duration-1", "duration-2", "duration-3"];
  const lessons = [
    ["lesson-1", "lesson-2", "lesson-3"],
    ["lesson-4", "lesson-5", "lesson-6"],
    ["lesson-7", "lesson-8", "lesson-9"],
  ];

  const columns = lessons.length + 1;
  const rows = duration.length;

  return (
    <div>
      <h1 className="my-4">Buttons</h1>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-3 lg:grid-cols-6">
        <Button theme="primary">Primary</Button>
        <Button theme="secondary">Secondary</Button>
        <Button theme="accent">Accent</Button>
        <Button theme="success">Success</Button>
        <Button theme="warning">Warning</Button>
        <Button theme="error">Error</Button>
      </div>
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Menu</h1>
      <div>
        <Menu>
          <Float
            placement="bottom-start"
            flip={0}
            offset={4}
            transform
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Button
              className={
                ComponentStyles["primary"] + "relative inline-block text-left"
              }
            >
              Menu
            </Menu.Button>
            <Menu.Items className="w-56 divide-y divide-gray-100 rounded-md bg-white text-nid_black shadow-lg ring-1 ring-black/5 focus:outline-none">
              <div className="px-1 py-1 ">
                <Menu.Item>
                  {({ active }) => (
                    <a
                      className={`${
                        active && "bg-blue-500"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      href="/"
                    >
                      Account settings
                    </a>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <a
                      className={`${
                        active && "bg-blue-500"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      href="/"
                    >
                      Profile
                    </a>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <a
                      className={`${
                        active && "bg-blue-500"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      href="/"
                    >
                      Some other
                    </a>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <a
                      className={`${
                        active && "bg-blue-500"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      href="/"
                    >
                      Playground
                    </a>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Float>
        </Menu>
      </div>
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Grid</h1>
      <div
        className="grid gap-0"
        style={{
          gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
          gridTemplateRows: `repeat(${rows}, minmax(0, 1fr))`,
        }}
      >
        {/* Empty cell for the first row, first column (no title for duration) */}
        <div className="border border-gray-200 bg-transparent p-4 "></div>

        {/* Titles for the lesson columns */}
        {titles.map((title, colIndex) => (
          <div
            key={`title-${colIndex}`}
            className="border border-gray-200 bg-gray-300 p-4 text-center font-bold"
            style={{ gridColumn: colIndex + 2, gridRow: 1 }}
          >
            {title}
          </div>
        ))}

        {/* First column for durations (displaying vertically) */}
        {duration.map((dur, rowIndex) => (
          <div
            key={`duration-${rowIndex}`}
            className="flex items-center justify-center border border-gray-200 bg-gray-100 p-4"
            style={{ gridColumn: "1", gridRow: rowIndex + 2 }} // Starting from row 2
          >
            {dur}
            <div className="ml-2 h-7 w-7 rounded-full bg-th-primary-900"></div>
          </div>
        ))}

        {/* Populate the rest of the grid with lessons */}
        {lessons.map((lessonColumn, colIndex) =>
          lessonColumn.map((lesson, rowIndex) => (
            <div
              key={`lesson-${colIndex}-${rowIndex}`}
              className="flex items-center justify-center border border-gray-200 bg-gray-100 p-4"
              style={{
                gridColumn: colIndex + 2, // +2 because column 1 is for duration
                gridRow: rowIndex + 2, // +2 because row 1 is for titles
              }}
            >
              {lesson}
            </div>
          )),
        )}
      </div>
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Textbox</h1>
      <Input
        type="text"
        id="test"
        name="test"
        label="Test"
        placeholder="Write your text here..."
      ></Input>
      <h1 className="my-4">Textarea</h1>
      <TextArea
        id="test"
        rows={10}
        name="test"
        label="Test"
        placeholder="Write your text here..."
      ></TextArea>
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Listbox</h1>
      <div className="w-72">
        {people && (
          <ListBox
            values={people}
            value={selectedPerson}
            valueChanged={setSelectedPerson}
            itemDisabled={(item) => item.unavailable}
            valueIdentifier={(value) => value.id}
            valueKey={(value) => value.name}
            name="people"
          ></ListBox>
        )}
      </div>
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Combobox</h1>
      {people && (
        <NidComboboxSingle
          value={selectedElement}
          values={people}
          onValueChange={setSelectedElement}
          getDisplayText={(person) => person?.name}
          getSearchText={(person) => person?.name}
        ></NidComboboxSingle>
      )}
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Combobox Multi</h1>
      {people && (
        <NidComboboxMulti
          value={selectedElementMulti}
          values={people}
          onValueChange={setSelectedElementMulti}
          getDisplayText={(person) => person?.name}
          getSearchText={(person) => person?.name}
        ></NidComboboxMulti>
      )}
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Datepicker</h1>
      <Input
        type="date"
        name="date"
        id="date"
        placeholder="Pick date"
        label="Event date"
      />
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Form</h1>
      <TestForm></TestForm>
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Editable Field</h1>
      <EditableInput
        initialValue="hallo"
        renderInput={(props) => (
          <Input name="hallo" id="hallo" label="" {...props} />
        )}
      ></EditableInput>
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Dialog</h1>
      <div className="flex space-x-2">
        <Button theme="primary" onClick={() => setIsOpen(true)}>
          Open Dialog
        </Button>
        <UiDialog
          open={isOpen}
          onClose={() => setIsOpen(false)}
          title="This is a dialog header"
        >
          <>
            <Dialog.Description className="mt-2 text-gray-800">
              This is the dialog description or content
            </Dialog.Description>

            <Button
              className="mt-4"
              theme="primary"
              onClick={() => setIsOpen(false)}
            >
              Close
            </Button>
          </>
        </UiDialog>
        <Button theme="primary" onClick={() => setIsFullscreenOpen(true)}>
          Open Fullscreen Dialog
        </Button>
        <FullscreenUiDialog
          open={isFullscreenOpen}
          onClose={() => setIsFullscreenOpen(false)}
          title="This is a dialog header"
        >
          <>
            <Dialog.Description className="mt-2 text-gray-800">
              This is the dialog description or content
            </Dialog.Description>

            <Button
              className="mt-4"
              theme="primary"
              onClick={() => setIsFullscreenOpen(false)}
            >
              Close
            </Button>
          </>
        </FullscreenUiDialog>
        <Button theme="primary" onClick={() => setIsTeacherDialogOpen(true)}>
          Open Teacher Dialog
        </Button>
        <CreateExternalTeacherDialog
          open={isTeacherDialogOpen}
          onClose={() => setIsTeacherDialogOpen(false)}
        ></CreateExternalTeacherDialog>
      </div>
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">API</h1>
      <Button theme="primary" className="mr-4" onClick={() => fetchFact()}>
        Call Cat Api
      </Button>
      <Button theme="primary" className="" onClick={() => fetchVacancies()}>
        Call Api
      </Button>
      {!isLoadingfact && fact && <div>{fact}</div>}
      {isLoadingfact && <div>Loading Fact ...</div>}
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Toggle</h1>
      <Toggle isEnabled={false} onToggle={(value) => {}}></Toggle>
      <hr className="-mx-4 my-4"></hr>
      <h1 className="my-4">Card</h1>
      <Card>
        <Card.Content>Test</Card.Content>
        <Card.Header>Asdf</Card.Header>
      </Card>
      <h1 className="my-4">Wizard</h1>
      <div className="h-[200px]">
        <Wizard>
          <Wizard.Step isValid={stepOneValid} name="Step 1">
            <Toggle
              isEnabled={stepOneValid}
              onToggle={(value) => {
                setStepOneValid(value);
              }}
            ></Toggle>
          </Wizard.Step>
          <Wizard.Step isValid={true} name="Step 2">
            Step 2
          </Wizard.Step>
          <Wizard.Step isValid={true} name="Step 3">
            Step 3
          </Wizard.Step>
        </Wizard>
      </div>
    </div>
  );
}

export default Playground;
